import { ArrowUpRight } from "lucide-react";
import { PageShell, ShellSection } from "./PageShell";
import { CONTACT, INQUIRIES, inquiryMailto } from "../data/content";
import { Reveal } from "../components/Reveal";

export default function ContactPage() {
    return (
        <PageShell
            testId="contact-page"
            overline="Contact"
            metaTitle="Contact — Titan Haven Group LLC"
            title="Serious inquiries, routed correctly."
            lede="Choose the lane that fits your inquiry — each one reaches a person at Titan Haven Group."
        >
            <ShellSection>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-thg-border border border-thg-border">
                    {INQUIRIES.map((item, i) => (
                        <Reveal key={item.name} delay={i * 0.05} className="bg-[#0a0a0a]">
                            <a
                                href={inquiryMailto(item.subject)}
                                data-testid={`contact-${item.testId}`}
                                className="group flex flex-col justify-between h-full p-8 hover:bg-thg-surface transition-colors duration-300"
                            >
                                <div>
                                    <h2 className="font-display text-lg md:text-xl font-medium text-white">{item.name}</h2>
                                    <p className="mt-3 text-sm leading-relaxed text-thg-secondary">{item.text}</p>
                                </div>
                                <span className="mt-6 inline-flex items-center gap-2 text-xs tracking-[0.15em] uppercase text-thg-tertiary group-hover:text-white transition-colors duration-300">
                                    Start inquiry <ArrowUpRight size={14} />
                                </span>
                            </a>
                        </Reveal>
                    ))}
                </div>
            </ShellSection>
            <ShellSection>
                <Reveal className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div>
                        <h2 className="text-xs tracking-[0.2em] uppercase font-bold text-thg-tertiary">Email</h2>
                        <a
                            href={`mailto:${CONTACT.email}`}
                            data-testid="contact-email"
                            className="mt-3 block text-base text-white hover:text-thg-secondary transition-colors duration-300"
                        >
                            {CONTACT.email}
                        </a>
                    </div>
                    <div>
                        <h2 className="text-xs tracking-[0.2em] uppercase font-bold text-thg-tertiary">Phone</h2>
                        <a
                            href={CONTACT.phoneHref}
                            data-testid="contact-phone"
                            className="mt-3 block text-base text-white hover:text-thg-secondary transition-colors duration-300"
                        >
                            {CONTACT.phone}
                        </a>
                    </div>
                    <div>
                        <h2 className="text-xs tracking-[0.2em] uppercase font-bold text-thg-tertiary">Structure</h2>
                        <p className="mt-3 text-base text-white">Wyoming LLC &middot; East Coast Operations</p>
                    </div>
                </Reveal>
            </ShellSection>
        </PageShell>
    );
}
